import { FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../../store/revisione53.reducers';
import { cloneDeep } from 'lodash-es';
import { MyVerbale } from '../../../../../models/interfaces/revisione.interface';

export const getSchedaCoopSocialiGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopSociali);

export const getSchedaCoopSocialiControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopSociali}.${path}`);

/** Required when my_ScSocObbl = 1 */
export const requiredByScSocObbl = (form: FormGroup, targetPath: string): void => {
    checkBoxHelper(form, targetPath, 'my_ScSocObbl', 1, formPaths.schedaCoopSociali);
};

/** Required when ckPath = ckTargetValue AND my_ScSocObbl = 1 */
export const schedaCoopSocialiCkHelper = (form: FormGroup, targetPath: string, ckPath: string, ckTargetValue: number, suppCondition = true, errorStatus?: string): void => {
    const my_ScSocObbl: string = getControl(getSchedaCoopSocialiGroup(form), 'my_ScSocObbl').value;
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, formPaths.schedaCoopSociali, suppCondition && my_ScSocObbl === '1', errorStatus);
};

export const controlloEventualiDiffida30PercentoSvant = (store: Store<Revisione53State>) => {
    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
        const warning = myVerbaleClone.my_Warning.my_ElWarning[4]; // IdWarning=5: persone svantaggiate <30%

        if (!warning || warning.my_VisibWarning === '') return myVerbaleClone;

        const soc = myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali;
        const hasCategoria = soc.my_CkAgricolo === '1' || soc.my_CkIndustr === '1' || soc.my_CkComm === '1' || soc.my_CkServiz === '1';

        if (soc.my_ScSocObbl !== '1' || !hasCategoria || isNaN(toNum(soc.my_PercentPersSvantagg))) {
            warning.my_VisibWarning = '0';
            return myVerbaleClone;
        }

        warning.my_VisibWarning = toNum(soc.my_PercentPersSvantagg) < 0.3 ? '1' : '0';
        return myVerbaleClone;
    });

    return false;
};

export const controlloEventualiDiffida50PercentoVolontari = (store: Store<Revisione53State>) => {
    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone = cloneDeep(myVerbale);
        const warning = myVerbaleClone.my_Warning.my_ElWarning[5]; // IdWarning=6: soci volontari >50%

        if (!warning || warning.my_VisibWarning === '') return myVerbaleClone;

        const soc = myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali;

        if (soc.my_ScSocObbl !== '1' || soc.my_CkSociVolontari !== '1' || isNaN(soc.my_PercentSociVolont)) {
            warning.my_VisibWarning = '0';
            return myVerbaleClone;
        }

        warning.my_VisibWarning = soc.my_PercentSociVolont > 0.5 ? '1' : '0';
        return myVerbaleClone;
    });

    return true;
};
